import React, { CSSProperties } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { RaptorTheme, mainColors } from '../../styling/theme';
import { Input, Tooltip, Typography } from '@mui/material';

interface GeneralInputProps {
  setInput: (inputVal: string | number) => void;
  inputValue: string | number;
  inputKey: string;
  inputTitle: string;
  width?: CSSProperties['width'];
  defaultValue?: string | number;
  usePlaceholder?: boolean;
  allowedValues?: (string | number)[];
}
interface StyleProps {
  width: CSSProperties['width'];
}

const useStyles = makeStyles<RaptorTheme, StyleProps>((theme) => ({
  divContainer: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 8,
    padding: '0.25rem 0.62rem',
    backgroundColor: theme.palette.grey[100],
  },
  inputTitle: {
    color: theme.palette.grey[600],
    marginRight: '0.62rem',
    whiteSpace: 'nowrap',
  },
  inputRoot: (props) => ({
    width: props.width,
  }),
  inputStyling: {
    color: mainColors.mainBlue,
  },
  inputStylingInvalid: {
    color: mainColors.Fail,
  },
  tooltipError: {
    backgroundColor: mainColors.Fail,
  },
}));

const GeneralInput: React.FC<GeneralInputProps> = (props) => {
  const {
    inputTitle,
    usePlaceholder,
    inputValue,
    setInput,
    allowedValues,
    width = '3.75rem',
  } = props;

  const classes = useStyles({ width });

  const [shownValue, setShownValue] = React.useState<string | number>(
    props.inputValue || '',
  );
  const [lastValidValue, setLastValidValue] = React.useState<string | number>(
    props.inputValue || '',
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setShownValue(e.target.value);
    if (props.allowedValues) {
      if (props.allowedValues.includes(e.target.value)) {
        setLastValidValue(e.target.value);
        props.setInput(e.target.value);
      }
    } else {
      setLastValidValue(e.target.value);
      props.setInput(e.target.value);
    }
  };

  return (
    <Tooltip
      title={
        (allowedValues && allowedValues.includes(shownValue)) || !allowedValues
          ? ''
          : 'Invalid Selection'
      }
      classes={{ tooltip: classes.tooltipError }}
    >
      <div className={classes.divContainer}>
        {!usePlaceholder && (
          <Typography variant="subtitle1" className={classes.inputTitle}>
            {inputTitle}
          </Typography>
        )}
        <Input
          classes={{
            input:
              (allowedValues && allowedValues.includes(shownValue)) ||
              !allowedValues
                ? classes.inputStyling
                : classes.inputStylingInvalid,
            root: classes.inputRoot,
          }}
          placeholder={usePlaceholder ? inputTitle : undefined}
          value={shownValue}
          onChange={handleChange}
          disableUnderline
          onBlur={() => {
            setShownValue(lastValidValue);
          }}
        />
      </div>
    </Tooltip>
  );
};

export default GeneralInput;
